/*LIBRARY*/
import { connect } from "react-redux";
import { useEffect } from "react";

/*COMPONENT*/
import LEFT_CONTENT from "./LEFT_CONTENT";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import ICON_LAYER from "../../Assets/jsx/ICON_LAYER";
import ICON_SIDEBAR_OPEN from "../../Assets/jsx/ICON_SIDEBAR_OPEN";

/*FUNCTION*/

/*DATA*/

/*CONST*/

const LEFT_CONTAINER = ({ properties, set_value_properties }) => {
  const is_mobile = properties?.is_mobile;

  useEffect(() => {
    if (is_mobile) {
      set_value_properties({
        key: "sidebar_left_status",
        value: false,
      });
    }
  }, [is_mobile, set_value_properties]);

  const { sidebar_left_status } = properties;

  const toggle_sidebar_left = () => {
    set_value_properties({
      key: "sidebar_left_status",
      value: !sidebar_left_status,
    });
  };

  return (
    <main>
      <section
        className="sidebar_left_map"
        style={{
          left: sidebar_left_status ? "7px" : "-320px",
          transition: "left 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
        }}
      >
        <LEFT_CONTENT />
      </section>
      <button
        className="close_sidebar_left"
        style={{
          left: sidebar_left_status ? "calc(289px + 15px)" : "15px",
          transition: "left 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
          backgroundColor: "#fff",
        }}
        onClick={toggle_sidebar_left}
      >
        {sidebar_left_status ? (
          <ICON_SIDEBAR_OPEN
            color="#000"
            style={{
              width: "17px",
            }}
          />
        ) : (
          <ICON_LAYER
            color="#000"
            style={{
              width: "15px",
            }}
          />
        )}
      </button>
    </main>
  );
};

const map_state_to_props = (state) => ({
  auth: state.auth,
  properties: state.properties,
});

export default connect(map_state_to_props, { set_value_properties })(
  LEFT_CONTAINER,
);
